import { CarTransferTypes } from '@app/entities/enums/ptrab/car-transfer-types.enum';

import { Company } from '../shared/company.model';

export class CarTransfer {
  id!: string;
  company!: Company;
  type!: CarTransferTypes;
  endDate!: string;
}
